import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { Form } from "react-final-form";

interface IFormModal<T> {
  onSubmit: (values: T) => void;
  open: boolean;
  title: string;
  children?: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onCancel: () => void;
  initialValues: T;
}

const FormModal = <T extends {}>(props: IFormModal<T>) => {
  const {
    onSubmit,
    open,
    title,
    children,
    confirmLabel,
    cancelLabel,
    onCancel,
    initialValues,
  } = props;

  return (
    <div>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle id="customized-dialog-title">{title}</DialogTitle>
        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <DialogContent dividers>{children}</DialogContent>
                <DialogActions>
                  <Button
                    onClick={onCancel}
                    variant="text"
                    size="small"
                    color="inherit"
                  >
                    {cancelLabel}
                  </Button>
                  <Button
                    autoFocus
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                  >
                    {confirmLabel}
                  </Button>
                </DialogActions>
              </div>
            </form>
          )}
        />
      </Dialog>
    </div>
  );
};

export default FormModal;
